import api from '@/api'
import * as types from './types'

export default {
  resetVisitedStep({ commit }, value) {
    commit(types.RESET_VISITED_STEP, value)
  },
  selectSubmodel({ commit }, id) {
    commit(types.SET_VEHICLE, id)
  },
  resetSubmodels({ commit }) {
    commit(types.RESET_SUBMODELS)
  },
  setSelectedChecklistItems({ commit }, data) {
    commit(types.SET_SELECTED_CHECKLIST_ITEMS, data)
  },
  setScanProChecklist({ commit }, data) {
    commit(types.SET_SCANPRO_CHECKLIST, data)
  },
  setScanProCriteria({ commit }, data) {
    commit(types.SET_SCANPRO_CRITERIA, data)
  },
  setCriteriaChanged({ commit }, value) {
    commit(types.SET_CRITERIA_CHANGED, value)
  },
  setCorporateId({ commit }, id) {
    commit(types.SET_CORPORATE_ID, id)
  },
  async setStep({ commit, state, dispatch }, value) {
    state.isLoading = true
    if (value !== 99) {
      commit(types.SET_STEP, value)
      commit(types.SET_VISITED_STEP, value)
      state.isLoading = false
    }
    if (state.criteriaChanged) {
      // if anything was changed, save the Scan Pro Criteria
      var data = {
        businessId: state.corporateId,
        criteria: state.scanProCriteria,
        checklist: state.scanProChecklist
      }
      return new Promise((resolve, reject) => {
        api.saveScanProConfiguration(data)
          .then(response => {
            resolve(response)
            commit(types.SET_CRITERIA_CHANGED, false)
            state.isLoading = false
          })
      })
    }
  },
  async getScanProConfiguration({ commit, state }) {
    state.isLoading = true
    return new Promise((resolve, reject) => {
      api.getScanProConfiguration(state.corporateId)
        .then(response => {
          state.isLoading = false
          commit(types.SET_SCANPRO_CONFIGURATION, response.data)
          resolve(response)
        })
    })
  },
  async decodeVin({ commit, state }, vin) {
    state.isLoading = true
    return new Promise((resolve, reject) => {
      api.decodeVin(vin)
        .then(response => {
          commit(types.SET_DECODED_VIN, { data: response.data, vin: vin })
          resolve(response)
          state.isLoading = false
        })
    })
  },
  async evaluateVehicle({ commit, state }, data) {
    state.isLoading = true
    return new Promise((resolve, reject) => {
      api.evaluateVehicle(data)
        .then(response => {
          resolve(response)
          commit(types.SET_RECOMMENDATION, response.data)
          state.isLoading = false
        })
    })
  },
  async saveScanProResults({ commit, state }, data) {
    state.isLoading = true
    return new Promise((resolve, reject) => {
      api.saveScanProResults(data)
        .then(response => {
          resolve(response)
          state.isLoading = false
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/scanpro/actions.js